import { useState } from 'react';
import { PiClipboardText } from 'react-icons/pi';
import { Card, Skeleton, Paginator } from '@/components/ui';
import { SEO } from '@/components/seo/SEO';
import { JobCard } from '@/components/job/JobCard/JobCard';
import { useFeed, useProfessions } from '@/api/worker';
import styles from './FeedPage.module.css';

const PAGE_SIZE = 10;

export function FeedPage() {
    const [page, setPage] = useState(1);
    const [profession, setProfession] = useState('');
    const [qualityTier, setQualityTier] = useState('');

    const { data: professions } = useProfessions();
    const { data, isLoading } = useFeed({
        profession: profession || undefined,
        quality_tier: qualityTier || undefined,
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
    });

    const jobs = data?.results || [];
    const totalPages = Math.ceil((data?.count || 0) / PAGE_SIZE);

    return (
        <div className={styles.container}>
            <SEO title="Feed de trabajos" description="Explora trabajos freelance disponibles. Filtra por profesion y nivel de calidad." path="/home" />
            <div className={styles.header}>
                <h1 className={styles.title}>Trabajos Disponibles</h1>
                <div className={styles.filters}>
                    <div className={styles.selectWrapper}>
                        <select
                            className={styles.select}
                            value={profession}
                            onChange={(e) => { setProfession(e.target.value); setPage(1); }}
                        >
                            <option value="">Todas las profesiones</option>
                            {professions?.map((p) => (
                                <option key={p.slug} value={p.slug}>{p.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className={styles.selectWrapper}>
                        <select
                            className={styles.select}
                            value={qualityTier}
                            onChange={(e) => { setQualityTier(e.target.value); setPage(1); }}
                        >
                            <option value="">Todos los niveles</option>
                            <option value="standard">Estandar</option>
                            <option value="premium">Premium</option>
                            <option value="expert">Experto</option>
                        </select>
                    </div>
                </div>
            </div>

            {isLoading ? (
                <div className={styles.grid}>
                    {Array.from({ length: 9 }).map((_, i) => (
                        <Card key={i}>
                            <div className={styles.skeletonRow}>
                                <Skeleton height={18} width="75%" />
                                <Skeleton height={22} width={70} variant="rounded" />
                            </div>
                            <div className={styles.skeletonBody}>
                                <Skeleton variant="text" width="100%" />
                                <Skeleton variant="text" width="90%" />
                            </div>
                            <div className={styles.skeletonTags}>
                                <Skeleton height={24} width={80} variant="rounded" />
                                <Skeleton height={24} width={64} variant="rounded" />
                            </div>
                            <div className={styles.skeletonFooter}>
                                <Skeleton width={100} height={22} variant="rounded" />
                                <Skeleton width={80} height={16} />
                            </div>
                        </Card>
                    ))}
                </div>
            ) : jobs.length === 0 ? (
                <div className={styles.empty}>
                    <div className={styles.emptyIconWrapper}>
                        <PiClipboardText className={styles.emptyIcon} />
                    </div>
                    <h3 className={styles.emptyTitle}>No hay trabajos disponibles</h3>
                    <p className={styles.emptyDescription}>Vuelve mas tarde o ajusta los filtros para encontrar nuevas oportunidades.</p>
                </div>
            ) : (
                <>
                    <div className={styles.grid}>
                        {jobs.map((job) => (
                            <JobCard key={job.uuid} job={job} />
                        ))}
                    </div>
                    {totalPages > 1 && (
                        <div className={styles.pagination}>
                            <Paginator page={page} numPages={totalPages} onPageChange={setPage} />
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
